import { css } from '@emotion/react';
import { ContextMenu, contextStyles } from '@birdi/context-menu/ContextMenu';
import { BirdiTheme } from '@birdi/theme';

interface MapsFolderMenuProps {
  disabled?: boolean;
  onSortAlphabetically: () => void;
}

export function MapsFolderMenu({
  disabled = false,
  onSortAlphabetically,
}: MapsFolderMenuProps) {
  return (
    <ContextMenu alignRight>
      {({ hide }) => (
        <div
          css={(theme: BirdiTheme) => css`
            ${contextStyles(theme)};
            min-width: 170px;
          `}
        >
          <button
            type="button"
            disabled={disabled}
            onClick={() => {
              onSortAlphabetically();
              hide();
            }}
          >
            Sort (A-Z)
          </button>
        </div>
      )}
    </ContextMenu>
  );
}
